
import { 
    GET_PAYER_CONFIGURATIONS,
    GET_PAYER_CONFIGURATIONS_SUCCESS,
    GET_PAYER_CONFIGURATIONS_FAIL, 
    GET_PAYER_CONFIGURATIONS_RESET,
} from "../actions/getPayerConfigurationsAction";

const initialState = {
    apiState: "",
    message: "",
    data: null,
    error: "",
}

const getPayerConfigurationsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_PAYER_CONFIGURATIONS:
            return {
                ...state,
                apiState: "loading",
            };
        case GET_PAYER_CONFIGURATIONS_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data,
                message: action.response.message ? action.response.message : "success",
            };
        case GET_PAYER_CONFIGURATIONS_FAIL:
            return {
                ...state,
                apiState: "error",
                error: action.response.errors,
                message: action.response.message ? action.response.message : "error",
            };
        case GET_PAYER_CONFIGURATIONS_RESET:
            return initialState;
        default: 
            return state;
    }
};

export default getPayerConfigurationsReducer;
